import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from 'src/app/shared/services/auth.service';
import { EmployeesService } from 'src/app/shared/services/employees.service';
import { RoleManagementService } from 'src/app/shared/services/role-management.service';

@Component({
  selector: 'app-edit-user-profile',
  templateUrl: './edit-user-profile.component.html',
  styleUrls: ['./edit-user-profile.component.scss']
})
export class EditUserProfileComponent implements OnInit {
  form!: FormGroup;
  selectedFile: File | null = null;
  roles: any[] = [];
  titles: string[] = ['Mr.', 'Ms.', 'Mrs.', 'Miss.'];
  loading = false;
  today: Date = new Date();

  constructor(
    private _EmployeesService: EmployeesService,
    private apiService: AuthService,
    private _snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<EditUserProfileComponent>,
    private fb: FormBuilder, 
    private roleManagementService: RoleManagementService,

    @Inject(MAT_DIALOG_DATA) public data: any) {
    // Form Create and Validation
    this.form = this.fb.group({
      title: ['', [Validators.required]],
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      middleName: [''],
      address1: ['', [Validators.required]],
      address2: [''],
      profileImage: [''],
      dob: ['', [Validators.required]],
      city: ['', [Validators.required]],
      country: ['', [Validators.required]],
      postalCode: ['', [Validators.required, Validators.pattern('^[1-9][0-9]{5}$|^[1-9][0-9]{3} [0-9]{3}$|^[1-9][0-9]{3}-[0-9]{3}$')]],
      phoneNo: ['', [Validators.required]]
    });
  }

  ngOnInit(): void {
    this.loading = true;
    this.Getuser();
    this.form.patchValue({
      profileImage: this.data.profile_pic ?
        'https://prod-foodism.s3.ap-south-1.amazonaws.com/' + this.data.profile_pic :
        '',
    })
    this.loading = false;
  }

  // Future Dates Are Disable
  myDateFilter = (d: Date | null): boolean => {
    const date = (d || new Date());
    return date < this.removeTime(this.today);
  };

  removeTime(date: Date): Date {
    date.setHours(0, 0, 0, 0);
    return date;
  }

  // Key Allow
  onKeyDown(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', '/'];
    const allowedKeyCodes = ['Digit0', 'Digit1', 'Digit2', 'Digit3', 'Digit4', 'Digit5', 'Digit6', 'Digit7', 'Digit8', 'Digit9', 'Numpad0', 'Numpad1', 'Numpad2', 'Numpad3', 'Numpad4', 'Numpad5', 'Numpad6', 'Numpad7', 'Numpad8', 'Numpad9', 'NumpadDecimal'];

    if (!allowedKeys.includes(event.key) && !allowedKeyCodes.includes(event.code)) {
      event.preventDefault();
    }
  }
  // Get User
  Getuser() {
    this.loading = true;
    this.apiService.getCurrentUser().subscribe({
      next: (res) => {
        // Patch User Value
        this.form.patchValue({
          title: res.data.title,
          firstName: res.data.first_name,
          lastName: res.data.last_name,
          middleName: res.data.middle_name,
          address1: res.data.address_line1,
          address2: res.data.address_line2,
          dob: res.data.dob,
          city: res.data.city,
          country: res.data.country,
          postalCode: res.data.post_code,
          phoneNo: res.data.phone_number
        });
        this.loading = false;
      },
      error: (err: any) => {
        this.loading = false;
      },
      complete: () => {
      }
    });
  }
  // File Select
  onFileSelected(event: any) {
    this.roleManagementService.checkUserRole().subscribe(isRoleActive => {
      if (isRoleActive) {
        const file: File = event.target.files[0];
        if (file) {
          this.selectedFile = file;
          this.form.patchValue({
            profileImage: URL.createObjectURL(file)
          });
        }
      }
    });
  }
  // Clear Image
  clearImage() {
    this.form.patchValue({
      profileImage: ''
    });
  }
  // Submit method
  onSubmit() {
    this.roleManagementService.checkUserRole().subscribe(isRoleActive => {
      if (isRoleActive) {
        if (this.form.valid) {
          // Update Profile
          // Date Format 
          const dob = new Date(this.form.value.dob);
          const year = dob.getFullYear();
          const month = (dob.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
          const day = dob.getDate().toString().padStart(2, '0');
          const dobFormatted = `${year}-${month}-${day}`;

          const formData = new FormData();
          formData.append('title', this.form.value.title);
          formData.append('first_name', this.form.value.firstName);
          formData.append('last_name', this.form.value.lastName);
          formData.append('middle_name', this.form.value.middleName);
          formData.append('dob', dobFormatted);
          formData.append('address_line1', this.form.value.address1);
          formData.append('address_line2', this.form.value.address2);
          formData.append('city', this.form.value.city);
          formData.append('country', this.form.value.country);
          formData.append('post_code', this.form.value.postalCode);
          formData.append('phone_number', this.form.value.phoneNo);
          if (this.selectedFile) {
            formData.append('profile_pic', this.selectedFile, this.selectedFile.name);
          }
          this.loading = true;
          this._EmployeesService.ProfileUpdate(formData).subscribe({
            next: (res) => {
              this.dialogRef.close();
              this._snackBar.open(res.message, 'Close', {
                duration: 3000,
              });
              this.loading = false
            },
            error: (err: any) => {
              this.loading = false;
            }
          });
        }
        else {
          Object.keys(this.form.controls).forEach(key => {
            this.form.get(key)?.markAsTouched();
          });
        }
      }
    });
  }
}
